import Vue from "vue";
import Vue2Filters from "vue2-filters";
import App from "./App.vue";
import store from "./services/store";
import router from "./services/router";
import "./services/config/pwa/registerServiceWorker";
import vuetify from "./services/config/plugins/vuetify";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

/**
 * CSS
 */
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "./styles/global.scss";


/**
 * Firebase
 */
import * as firebase from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAfl7ot1mj17u2uy665nhN7lJh2nZcoh0E",
  authDomain: "cancontrol-fd9cc.firebaseapp.com",
  databaseURL: "https://cancontrol-fd9cc.firebaseio.com",
  projectId: "cancontrol-fd9cc",
  storageBucket: "cancontrol-fd9cc.appspot.com",
  messagingSenderId: "723559547681",
  appId: "1:723559547681:web:794809101544c0604db460",
  measurementId: "G-FX8245EBD0"
};

const app =  firebase.initializeApp(firebaseConfig);
getAnalytics(app);
const db = getFirestore(app);

Vue.prototype.$db = db;

Vue.use(Vue2Filters);
Vue.use(Viewer);


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
